import {
    GET_ST_MANAGEMENT_LIST,
    CLEAR_ST_MANAGEMENT_LIST,
    GET_ST_APPLY_CHANGE_SUPPLY_CENTER_LIST,
    GET_ST_TRANSPORT_METHOD_LIST,
} from 'Actions/stManagement';
import update from 'immutability-helper';

const initialState = {};

export function stManagement(state = initialState, action) {
    let payload = {};
    switch (action.type) {
        case CLEAR_ST_MANAGEMENT_LIST:
            return {...state, stManagementList: []};
        case GET_ST_MANAGEMENT_LIST:
            if (action.payload.pageNum === 1)
                payload.stManagementList = action.payload.data;
            if (action.payload.pageNum > 1) {
                payload.stManagementList = state.stManagementList.concat(
                    action.payload.data,
                );
            }
            return {...state, ...payload};
        case GET_ST_APPLY_CHANGE_SUPPLY_CENTER_LIST:
            payload.applySupplyCenterList = action.payload.data;
        case GET_ST_TRANSPORT_METHOD_LIST:
            payload.transportMethodList = action.payload.data;
        default:
            return state;
    }
}
